import {
    CalendarToday as IconAvailableStatus,
    EventAvailable as IconScheduledStatus,
    EventBusy as IconUnavailableStatus,
} from "@mui/icons-material";
import { Checkbox, Paper, Stack, Typography } from "@mui/material";
import { Control, Controller } from "react-hook-form";

import { FieldworkerPlanningFormValues } from "../FieldworkerPlanning";

type Props = {
    availabilityIndex: number;
    control: Control<FieldworkerPlanningFormValues, unknown>;
    dayIndex: number;
    disabled: boolean;
    name: string;
};

export default function FieldworkerAvailabilityEvent({ availabilityIndex, control, dayIndex, disabled, name }: Props) {
    return (
        <Controller
            name={`elements.${dayIndex}.availabilities.${availabilityIndex}.isAvailable`}
            control={control}
            render={({ field: { onChange, value } }) => {
                const backgroundColor = disabled ? "secondary.main" : value ? "primary.main" : "background.default";
                const textColor = value ? "primary.contrastText" : "text.primary";
                const icon = disabled ? <IconScheduledStatus /> : value ? <IconAvailableStatus /> : <IconUnavailableStatus />;

                return (
                    <Paper
                        sx={{
                            backgroundColor,
                            color: textColor,
                            paddingLeft: 1,
                            cursor: disabled ? "default" : "pointer",
                        }}
                        onClick={() => {
                            if (disabled) return;
                            onChange(!value);
                        }}
                    >
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" alignItems="center" columnGap={1}>
                                {icon}
                                <Typography
                                    sx={{
                                        color: textColor,
                                    }}
                                    variant="body2"
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                >
                                    {name}
                                </Typography>
                            </Stack>

                            <Checkbox
                                sx={{
                                    color: textColor,
                                    paddingRight: "8px",
                                    visibility: disabled ? "hidden" : "visible",
                                }}
                                color="default"
                                checked={!!value}
                                disabled={disabled}
                            />
                        </Stack>
                    </Paper>
                );
            }}
        />
    );
}
